import React, { type FC, memo } from "react";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_GRADE_SELECTOR_COMPARE } from "../../../../utils/modalConstants";
import type { GradeSelectorDispatchType } from "../../../../redux/store";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { GradeSelectorMemoLabel } from "../../../../utils/labels";

import styles from "./Item.module.scss";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const CompareButton: FC<{ gradeId: string; submodelId?: string }> = ({ gradeId, submodelId }) => {
    const dispatch = useDispatch<GradeSelectorDispatchType>();
    return (
        <Button
            type="button"
            onClick={() =>
                dispatch(showModal({ type: MODAL_GRADE_SELECTOR_COMPARE, models: [{ gradeId, submodelId }] }))
            }
            variant="btn-secondary"
            sizing="full-width"
            className={styles.button}
        >
            <GradeSelectorMemoLabel label="gradeSelectorCompare" />
            <Icon variant="arrow-long-right" sizing="sm" aria-hidden="true" />
        </Button>
    );
};

export default memo(CompareButton);
